@let dashboardUser = dashboardUser$ | async;
@let lastSelectedViewRegion = lastSelectedViewRegion$ | async;

<div class="dashboard-study-data-zone">
  <div class="dashboard-study-data-zone__general-info">
    <div class="dashboard-study-data-zone__region-name">Your {{lastSelectedViewRegion?.name}} measured</div>
    <div class="dashboard-study-data-zone__percentile-short">
      in the typical range for
      {{ dashboardUser?.sex === dashboardUserSex.Female ? 'Female' : 'Male' }}
      your age</div>
  </div>

  <div class="dashboard-study-data-zone__chart">
    <img
      class="dashboard-study-data-zone__chart-image"
      ngSrc="/assets/temporal/graph-mock.png"
      width="656"
      height="289"
      alt="mock-graph"
    >
  </div>

  <div class="dashboard-study-data-zone__data-view">
    <app-dashboard-study-data-view></app-dashboard-study-data-view>
  </div>
</div>
